import React from 'react'
import { Navigate, useLocation, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../app/store'
import { getAuthToken, getUserData } from '../utils/secureStorage'

const ProtectedRoute: React.FC = () => {
  const location = useLocation()
  const { isAuthenticated: reduxIsAuthenticated, isLoading, user, token } = useSelector((state: RootState) => state.auth)

  // Also check secure storage as fallback to handle timing issues
  const tokenFromStorage = getAuthToken()
  const userFromStorage = getUserData()
  const isAuthenticated = reduxIsAuthenticated || (!!tokenFromStorage && !!userFromStorage)

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="loading-spinner"></div>
      </div>
    )
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <Outlet />
}

export default ProtectedRoute
